// @flow

import { getCookie } from '../cookie'
import * as browserEnv from '../browserEnv'
import * as fjApp from '../app/fengjr'

export type Tracker = {
  init(): void,
  trackPageview(page?: string, prePage?: string): void,
  trackEvent(name: string): void,
  trackEventValue(name: string, value: string | {}): void,
  setUid(uid: string): void,
  setCustomVar(key: string, value: string): void
};

export default function (trackers: Tracker[]): Tracker {
  return {
    init () {
      let channel = getCookie('channel')

      // set channel,  browserEnv
      trackers.forEach(tracker => {
        tracker.init()
        if (channel) {
          tracker.setCustomVar('channel', channel)
        }
        tracker.setCustomVar(
          'browserEnv',
          browserEnv.isInWeixin() ? 'weixin' : 'app'
        )
      })

      if (browserEnv.isInFjApp()) {
        // 获取 FengjrApp 信息
        fjApp.getSessionInfo((info: ?{ seq: number, session_id: string }) => {
          trackers.forEach(tracker => {
            if (info) {
              tracker.setCustomVar('app_seq', String(info.seq))
              tracker.setCustomVar('app_session_id', info.session_id)
            }
          })
        })
      }
    },

    trackPageview (page?: string, prePage?: string) {
      trackers.forEach(tracker => tracker.trackPageview(page, prePage))
    },

    trackEvent (name: string) {
      trackers.forEach(tracker => tracker.trackEvent(name))
    },

    trackEventValue (name: string, value: string | {}) {
      trackers.forEach(tracker => tracker.trackEventValue(name, value))
    },

    setUid (uid: string) {
      trackers.forEach(tracker => tracker.setUid(uid))
    },

    setCustomVar (key: string, value: string) {
      trackers.forEach(tracker => tracker.setCustomVar(key, value))
    }
  }
}



// WEBPACK FOOTER //
// ./src/frame/core/analysis/combine.js